export default "__VITE_ASSET__CKR3a4bK__"